import bgVideo from "../assets/videos/youMail_loading.mp4";
import { Link } from "react-router-dom";
import NavBar from "../components/nav_bar";
import t from "../locales";
import { useNotepadStore } from "../store/notepad";
import youMailIcon from "../assets/images/you_mail.png";
import envelopeIcon from "../assets/images/you_mail/icon_envelope.svg";
import dynamicFrame from "../assets/images/you_mail/arrows.svg";
import SystemMessage from "../components/system_message";
import { useEffect, useState } from "react";

export default function YouMail() {
  const passwordFound = useNotepadStore((state) => state.secrets.password);
  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <>
      {passwordFound ? (
        <SystemMessage text={t("youmail_system_message_found")} />
      ) : (
        <SystemMessage
          text={t("youmail_system_message_not_found")}
          type="notAllowed"
        />
      )}
      {loggedIn ? (
        <BruteForce />
      ) : (
        <>
          <NavBar icon={youMailIcon} />
          <Login onLogin={() => setLoggedIn(true)} />
        </>
      )}
    </>
  );
}

function Login({ onLogin }) {
  const handleLogin = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    if (data.get("password") === "correctPassword") onLogin();
  };
  return (
    <>
      <form className="you-mail" onSubmit={handleLogin}>
        <img className="you-mail__envelope" src={envelopeIcon} />
        <div className="you-mail__input-container">
          <label className="you-mail__label" htmlFor="you-mail__select-email">
            {t("youmail_email_adress")}
          </label>
          <input
            readOnly
            className="you-mail__input"
            id="you-mail__select-email"
            value={t("secrets_email_value")}
          />
        </div>
        <div className="you-mail__input-container">
          <label className="you-mail__label" htmlFor="password">
            {t("youmail_password")}
          </label>
          <select
            className="you-mail__select"
            id="password"
            name="password"
            defaultValue=""
          >
            <option value="" disabled></option>
            <option value="correctPassword" className="you-mail__option">
              {t("secrets_password_value")}
            </option>
          </select>
        </div>

        <button className="button you-mail__button" type="submit">
          {t("youmail_log_in")}
        </button>
      </form>
    </>
  );
}

function ProgressInfo() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (progress >= 100) return;

    setTimeout(() => {
      setProgress((v) => v + Math.max(Math.floor(Math.random() * 3), 1));
    }, Math.random() * 75);
  }, [progress]);
  return (
    <div className="you-mail__loading-frame">
      <img src={dynamicFrame} />
      {progress < 100 ? (
        <div className="you-mail__progress-line">
          <p className="you-mail__frame-percentage">{progress}% </p>
          <div className="you-mail__progress-bar">
            <div
              className="you-mail__progress-bar-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      ) : (
        <div className="you-mail__progress-line">
          <p className="you-mail__frame-text">{t("youmail_hacked")}</p>
        </div>
      )}
      <img src={dynamicFrame} />
    </div>
  );
}

function BruteForce() {
  return (
    <>
      <nav className="nav-bar nav-bar--youmail">
        <Link to="/einde" className="nav-bar__link">
          {t("nav_bar_end")}
          <svg
            className="nav-bar__link-icon"
            viewBox="0 0 36 36"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              transform="rotate(180 18 18)"
              d="M20.6828 33.1022L18.9486 34.8819C18.2143 35.6354 17.027 35.6354 16.3005 34.8819L1.11468 19.3058C0.380392 18.5523 0.380392 17.3338 1.11468 16.5882L16.2927 1.01218C17.027 0.258633 18.2143 0.258633 18.9408 1.01218L20.675 2.79184C21.4171 3.55341 21.4015 4.79597 20.6438 5.5415L11.2386 14.7364L33.6892 14.7364C34.7281 14.7364 35.564 15.5942 35.564 16.6604V19.2257C35.564 20.2918 34.7281 21.1496 33.6892 21.1496L11.2386 21.1496L20.6516 30.3525C21.4171 31.0981 21.4327 32.3406 20.6828 33.1022Z"
            />
          </svg>
        </Link>
      </nav>
      <div className="you-mail__brute-force">
        <video
          className="you-mail__bgvideo"
          loop
          autoPlay
          muted
          type="video/mp4"
          id="you-mail__bgvideo"
        >
          <source src={bgVideo} />
        </video>
        <div className="you-mail__content">
          <ProgressInfo />
        </div>
      </div>
    </>
  );
}
